import React from 'react';

import {
  GenreSimplifieDto,
  ReferentielSearchResultDtoGenreSimplifieDto,
} from 'lib_api/lib/api/gen';

import Table from 'components/WrappedComponents/Table/Table';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { useDashboardSearchWithSort } from 'hooks/search/useDashboardSearchWithSort';
import { DEFAULT_PAGE_SIZE_OPTIONS } from 'utils/global';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import CellDetailsAndActions from './CellDetailsAndActions';
import { FilterDashboardGenreSimplifie, GenreSimplifieSort } from './types';
import { useSearchGenreSimplifie } from './utils';

function buildColumns(
  refreshDashboard: () => void,
): ColumnProps<GenreSimplifieDto, GenreSimplifieSort>[] {
  return [
    {
      title: 'Libellé',
      buildCellContent: data => data.libelle,
      sortedField: 'LIBELLE',
    },
    {
      title: 'Dicem',
      buildCellContent: data => (data.dicem ? 'Oui' : 'Non'),
    },
    {
      title: 'Formats plaque',
      buildCellContent: data => data.formatsPlaque.join(','),
    },
    {
      title: '',
      buildCellContent: data => (
        <CellDetailsAndActions
          genreSimplifie={data}
          refreshDashboard={refreshDashboard}
        />
      ),
    },
  ];
}

function DashboardGenreSimplifie(): React.ReactElement {
  const {
    fetchData,
    pagination,
    setPagination,
    filter,
    setFilter,
    sort,
    setSort,
    refreshDashboard,
  } = useDashboardSearchWithSort<
    GenreSimplifieDto,
    FilterDashboardGenreSimplifie,
    GenreSimplifieSort,
    ReferentielSearchResultDtoGenreSimplifieDto
  >(
    useSearchGenreSimplifie,
    {
      valid: true,
    },
    {
      LIBELLE: true,
    },
    'paginationAdministrationGenresSimplifie',
  );
  return (
    <div className="table-container">
      <Table
        columns={buildColumns(refreshDashboard)}
        fetchData={fetchData}
        header={fetchedData => (
          <DashboardHeader
            totalCount={fetchedData?.total || 0}
            refreshDashboard={refreshDashboard}
            filter={filter}
            setFilter={setFilter}
          />
        )}
        buildItemKey={(item): string => item.id}
        filter={filter}
        setFilter={setFilter}
        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
        pagination={pagination}
        setPagination={setPagination}
        sort={sort}
        setSort={setSort}
      />
    </div>
  );
}

export default DashboardGenreSimplifie;
